import type { userFormData } from "@/features/userManagement/components/userFormModal/types.props";
import type { user } from "@/types/api/user.api";
import type { userFilters } from "@/types/filters/filters.domain";
import { createApiService } from "./apiServiceFactory";

export const userService = createApiService<user, userFilters, userFormData>(
    "users",
);
